import styled from 'styled-components';

export const StyledRegionalRiskHighLevelStatistics = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;

  @media (max-width: 768px) {
    height: auto;
    overflow: visible;
  }
`;
